import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { TEXTAREA_ROW_LENGTH } from '../../../constants/constants';
import validCharacters from '../../../constants/valid-characters';
import {
  IAddProcess,
  IUpdateProcess,
} from '../../../models/forms/IAddUpdateProcess';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import { IOption } from '../../../models/ICommon';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import { ProcessValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import DefaultModalDraggable from '../../../shared-components/modal/default-modal-draggable';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import React from 'react';
import { formatMessage } from '../../../translations/format-message';

interface IProps extends IAddEditFormProps<IAddProcess | IUpdateProcess> {
  processTypeOptions: IOption[];
}

const AddProcessForm = ({
  id,
  initialValues,
  isLoading,
  processTypeOptions,
  submitHandler,
  onModalClosed,
}: IProps) => {
  const PROCESS_NAME_MAX_LENGTH = 256;
  return (
    <>
      <DefaultModalDraggable
        onModalClosed={onModalClosed}
        headerText={id < 0 ? 'add_process' : 'update_process'}
        isLoading={isLoading}
        className="addProcess"
        saveUpdateBtnText={id < 0 ? 'save' : 'update'}
        cancelBtnText={'cancel'}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={ProcessValidateSchema}
          validateOnBlur={false}
          onSubmit={async (values) => {
            submitHandler(values);
          }}
        >
          {({ values }) => {
            return (
              <Form className="process-form">
                {isLoading && <FormLoader loading={isLoading} contained />}
                <Modal.Body>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="process_name"
                        />
                        <Field
                          data-testid="testProcessName"
                          className="form-control"
                          name="ProcessName"
                          type="text"
                          placeholder=""
                          as={FormikFormInput}
                          maxLength={PROCESS_NAME_MAX_LENGTH}
                          validcharacter={validCharacters}
                        />
                        {String(values.ProcessName || '').length >=
                          PROCESS_NAME_MAX_LENGTH && (
                          <div className="invalid-feedback d-block errorMessage">
                            {formatMessage('max_char_limit_256')}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="short_name"
                        />
                        <Field
                          data-testid="testProcessName"
                          className="form-control"
                          name="ShortName"
                          type="text"
                          placeholder=""
                          as={FormikFormInput}
                          maxLength={5}
                        />
                        {String(values.ShortName || '').length >= 5 && (
                          <div className="invalid-feedback d-block errorMessage">
                            {formatMessage('max_char_limit_5')}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="process_type"
                        />
                        <Field
                          name="Type"
                          as={FormikFormSelect}
                          options={processTypeOptions}
                          setDefaultValue={true}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={false}
                          label="Comment"
                        />
                        <Field
                          rows={TEXTAREA_ROW_LENGTH}
                          id="Comment"
                          className="form-control"
                          name="Comment"
                          placeholder=""
                          type="text"
                          as={FormikFormTextArea}
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <ModalFooter
                  id={id}
                  onModalClosed={onModalClosed}
                  isLoading={isLoading}
                  saveNextBtn={'save'}
                  backCancelBtn="cancel"
                />
              </Form>
            );
          }}
        </Formik>
      </DefaultModalDraggable>
    </>
  );
};

export default AddProcessForm;
